<template>
  <v-container fluid class="espacios blue-grey lighten-1">
    <v-layout wrap align-center>
      <v-flex xs12 sm12 d-flex pa-0>
        <v-select
          v-model="select"
          :items="items"
          item-text="dep"
          item-value="abbr"
          label="Elija"
          single-line
          class="body-1"
        ></v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      select: { dep: "RRHH", abbr: "RRHH" },
      items: [
        { dep: "RRHH", abbr: "RRHH" },
        { dep: "DGOI", abbr: "DGOI" }
      ]
    };
  }
};
</script>

<style >
.v-navigation-drawer--mini-variant
  div[role="combobox"]
  .v-select__selection--comma {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  width: 5em;
}
.espacios .v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.espacios .v-input__slot {
  margin-bottom: 0;
}
.espacios .v-text-field>.v-input__control>.v-input__slot:after, 
.espacios .v-text-field>.v-input__control>.v-input__slot:before
{display:none}

.container.espacios {
  padding: 10px 10px 0 20px;
}
</style>
